
import request from '@/utils/request'

export default {
  getListByParentId(data) {
    console.log('getListByParentId : ',data)
    return request({
      url: '/rescategory/getListByParentId',
      method: 'post',
      data
    })
  }

}





// WEBPACK FOOTER //
// ./src/api/rescategory.js